export default __webpack_public_path__ + "static/media/saving-schedule.9648bd7d.png";